import { makeStyles } from '@material-ui/core/styles';
import { input } from 'UI/constants/dimensions';
import { colors } from 'UI/res';
import { getIconColor, isDarkTheme } from 'UI/theme/darkTones';

export const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 389,
    height: input.height,
    borderRadius: input.borderRadius,
    borderColor: colors.componentFill,
    borderWidth: 1
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    color: colors.black
  },
  iconButton: {
    color: getIconColor(theme, colors.middleGrey),
    '&:hover': {
      '& path': {
        fill: isDarkTheme(theme) ? theme.palette.text.primary : colors.middleGrey
      }
    }
  }
}));
